import * as momentNs from 'moment';
// tslint:disable-next-line:typedef
const moment = momentNs;

export class MinervaReferenceData {
  id: string;
  correlationId: string;
  code: string;
  description: string;
  effectiveFrom: momentNs.Moment;
  effectiveUntil: momentNs.Moment;
  sortSequence: number;

  // tslint:disable-next-line:no-any
  constructor(referenceData: any) {
    this.id = referenceData.id;
    this.correlationId = referenceData.correlationId;
    this.code = referenceData.code;
    this.description = referenceData.description;
    this.effectiveFrom = moment(referenceData.effectiveFrom, 'YYYY-MM-DD');
    this.sortSequence = referenceData.sortSequence;

    if (referenceData.effectiveUntil) {
      this.effectiveUntil = moment(referenceData.effectiveUntil, 'YYYY-MM-DD');
    }
  }

  get label(): string {
    return this.description;
  }

  get value(): string {
    return this.correlationId;
  }
}
